import { useEffect, useState, useRef } from "react"
import { kebabCase } from "lodash"
import { motion, useViewportScroll, useTransform } from "framer-motion"
import Scrollspy from "react-scrollspy"
import AnchorLink from "react-anchor-link-smooth-scroll"
import { useWindowDimensions } from "utils/useWindowDimensions"
import { ChevronIcon } from "assets/icons"

const Subnav = ({ items }) => {
  let width
  const ref = useRef()
  const [isTop, setIsTop] = useState(true)

  const { scrollY, scrollYProgress } = useViewportScroll()

  const { width: vw } = useWindowDimensions()
  width = useTransform(scrollYProgress, [0.075, 1], [0, vw])

  const update = () => {
    if (scrollY?.current < scrollY?.prev) {
      if (scrollY?.current - 100 > ref.current?.offsetTop) {
        setIsTop(false)
      } else {
        setIsTop(true)
      }
    } else if (scrollY?.current > 20 && scrollY?.current > scrollY?.prev) {
      setIsTop(true)
    }
  }

  useEffect(() => {
    return scrollY.onChange(() => update())
  })

  const variants = {
    top: { y: 0 },
    pushed: { y: vw >= 768 ? 100 : 90 },
  }

  return (
    <>
      <div ref={ref}></div>
      <motion.div
        className="subnav bg-white border-t border-b border-grey/50 mt-12 sticky top-0 z-[60]"
        variants={variants}
        animate={isTop ? "top" : "pushed"}
        transition={{ ease: "easeInOut", duration: 0.5 }}
      >
        <Scrollspy
          className="content flex gap-8 justify-start md:justify-around !max-w-[900px] uppercase tracking-widest py-4 overflow-x-auto"
          items={items.map((item) => item && kebabCase(item))}
          currentClassName="active font-semibold antialiased"
          componentTag="div"
          offset={-50}
        >
          {items.map(
            (item, index) =>
              item && (
                <motion.div
                  initial="hidden"
                  animate="show"
                  variants={{
                    hidden: { opacity: 0, y: 30 },
                    show: {
                      opacity: 1,
                      y: 0,
                      transition: {
                        opacity: {
                          duration: 0.8,
                          ease: "easeOut",
                          delay: index * 0.1,
                        },
                        y: {
                          duration: 0.6,
                          ease: "easeOut",
                          delay: index * 0.1,
                        },
                      },
                    },
                  }}
                >
                  <AnchorLink
                    key={index}
                    href={`#${kebabCase(item)}`}
                    offset={50}
                    className="text-center text-sm flex items-center space-x-3"
                  >
                    <div className="chevron-conatiner border border-blue rounded-full flex items-center justify-center w-5 h-5">
                      <ChevronIcon className="w-2.5 h-2.5 rotate-90 mt-0.5" />
                    </div>
                    <span>{item}</span>
                  </AnchorLink>
                </motion.div>
              )
          )}
          {/* </motion.div> */}
        </Scrollspy>
        <motion.div className="w-full h-[2px] bg-blue-300 absolute -bottom-0.5 left-0" style={{ width: width }} />
      </motion.div>
    </>
  )
}

export default Subnav
